export class CompanyPreference {
  public companyCurrency: string = "";
  public companyCountryCode: string = "";
  public companyDateFormat: string = "";
  public companyDistanceUnit: string = "";
  public companyRadiusMax: string = "";
  public companyRadiusMin: string = "";
  public companyLocale: string = "";
  public timeZone: string = "";
  public termsLink: string = "";
  public privacyLink: string = "";
  public homePageURL: string = "";
}
